import styled from 'styled-components';

import {Select as BaseSelect} from '@edna/components';

export const Select = styled(BaseSelect)`
  width: 100%;
  max-width: 450px;
`;
